import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _class, _AbPopupHeader;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { BaseRCmp } from "abreact/incubator/ui/component/BaseRCmp";
import { withAbPopupContext } from "abreact/incubator/ui/popup/PopupContext";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbButton } from "abreact/misc/AbButton";
import { AbHeader } from "abreact/misc/AbHeader";
import { AbImage } from "abreact/misc/AbImage";
import { AbSize } from "abreact/misc/AbSize";
import { TypeUtils } from "abweb/utils/TypeUtils";
import { observer } from "mobx-react";
import * as React from "react";

/**
 * The properties that can be provided when constructing a popup's header.
 */

export const helpButtonService = {
  helpButtonRenderer: undefined
};

/**
 * A header component that can be shown in a popup.
 */
let AbPopupHeader = observer(_class = (_AbPopupHeader = class AbPopupHeader extends BaseRCmp {
  closeDialog() {
    this.props.popupContext?.popupHandle.close();
  }
  renderCustomButtons(buttons) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, buttons.map(button => /*#__PURE__*/React.createElement(AbButton, _extends({}, button, {
      className: ReactUtils.classNamesString([button.className, "ab-no-border-button", "ab-popup-custom-button"]),
      key: TypeUtils.itemToKey(button, undefined)
    }))));
  }
  renderDefaultCloseButton() {
    return /*#__PURE__*/React.createElement(AbButton, {
      className: "ab-popup-close-button ab-no-border-button",
      icon: "absdk:cancel",
      disabled: this.props.closeButtonDisabled,
      dataTestId: "close-ab-popup",
      tooltip: AbReactResources.popupHeader_close_tooltip(),
      onClick: () => this.closeDialog()
    });
  }
  renderDefaultMaximizeButton() {
    return /*#__PURE__*/React.createElement(AbButton, {
      className: "ab-popup-maximize-button ab-no-border-button",
      dataTestId: "maximize-button",
      icon: this.props.isMaximized ? "absdk:restore-down" : "absdk:maximize",
      tooltip: this.props.isMaximized ? AbReactResources.popupHeader_minimize_tooltip() : AbReactResources.popupHeader_maximize_tooltip(),
      onClick: () => this.props.onMaximize && this.props.onMaximize()
    });
  }
  render() {
    const imageIdentifier = typeof this.props.icon === "string" ? this.props.icon : undefined;
    const hasTitle = this.props.title !== null && this.props.title !== undefined;
    const onDoubleClick = event => {
      let walker = event.target;
      while (walker != null && walker !== event.currentTarget) {
        if (walker.nodeName === "BUTTON" || walker.nodeName === "A" || walker.nodeName === "INPUT") {
          return;
        }
        walker = walker.parentElement;
      }
      this.props.onMaximize && this.props.onMaximize();
    };
    return /*#__PURE__*/React.createElement("div", _extends({
      "data-test-component": "ab-popup-header"
    }, ReactUtils.componentProps("ab-popup-header", this.props), {
      onDoubleClick: onDoubleClick
    }), (imageIdentifier || this.props.icon) && /*#__PURE__*/React.createElement("div", {
      className: "ab-popup-header-icon"
    }, imageIdentifier && /*#__PURE__*/React.createElement("span", {
      className: "icon"
    }, /*#__PURE__*/React.createElement(AbImage, {
      image: imageIdentifier
    })), this.props.icon && !imageIdentifier && this.props.icon), hasTitle && /*#__PURE__*/React.createElement(AbHeader, {
      className: "ab-popup-header-title",
      id: this.props.titleID,
      size: AbSize.CUSTOM
    }, this.props.title), !hasTitle && /*#__PURE__*/React.createElement("div", {
      className: "ab-popup-header-spacer"
    }), (this.props.maximizeButton || this.props.closeButton || this.props.helpButton) && /*#__PURE__*/React.createElement("div", {
      className: "ab-popup-header-buttons"
    }, this.props.customButtons && this.props.customButtons.length > 0 && this.renderCustomButtons(this.props.customButtons), this.props.helpButton && helpButtonService.helpButtonRenderer?.(), this.props.maximizeButton && this.renderDefaultMaximizeButton(), this.props.closeButton && this.renderDefaultCloseButton()));
  }
}, _defineProperty(_AbPopupHeader, "defaultProps", {
  closeButton: true
}), _AbPopupHeader)) || _class;
/* Export a wrapped version of AbPopupHeader that receives the popup callbacks through context. */
let wrapped = withAbPopupContext(AbPopupHeader);
export { wrapped as AbPopupHeader };
//# sourceMappingURL=AbPopupHeader.js.map
